import clsx from 'clsx';
import { type CSSProperties, type HTMLAttributes } from 'react';
import { calculateSafeArea } from '~/utils';
import styles from './FloatingArea.module.css';

type Props = HTMLAttributes<HTMLDivElement> & {
  top?: CSSProperties['top'];
  left?: CSSProperties['left'];
  right?: CSSProperties['right'];
  bottom?: CSSProperties['bottom'];
};

export const FloatingArea = ({ top, left, right, bottom, className, style, ...props }: Props) => {
  return (
    <div
      {...props}
      className={clsx([className, styles.wrapper])}
      style={{
        ...style,
        top: calculateSafeArea(top, 'top'),
        left: calculateSafeArea(left, 'left'),
        right: calculateSafeArea(right, 'right'),
        bottom: calculateSafeArea(bottom, 'bottom'),
      }}
    />
  );
};
